import { Modal } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Select from "react-select"; // Importa react-select
import Swal from "sweetalert2";
import { obtenerListaEmpresas } from "../../../../store/Empresa/thunkEmpresa";
import { creditoOptions, tipoClienteOptions } from "../../../../hook/Arreglos";
import { crearCliente } from "../../../../store/clientes/thunkClientes";
import { useLocation } from "react-router-dom";

export const ModalCrearCliente = ({ open, onClose, functions }) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const [Empresas, setEmpresas] = useState([]);
    const [clientData, setClientData] = useState({
        nombre_cliente: "",
        correo_cliente: "",
        telefono_cliente: "",
        empresa_cliente: "",
        tipo_cliente: "Sin tipo",
        Monto_credito: "000000",
        credito_cliente: "No",
        estado_cliente: 1,
        cumpleanos: "",
        hijos: "0",
        notasImportantes: "sin notas",
        puesto: "",
    });

    const [errors, setErrors] = useState({});

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setClientData({ ...clientData, [name]: value });

        // Validación y eliminación del borde rojo
        if (value.trim() === "") {
            setErrors((prev) => ({ ...prev, [name]: "Este campo es obligatorio" }));
        } else if (name === "correo_cliente" && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
            setErrors((prev) => ({ ...prev, [name]: "El formato es inválido" }));
        } else {
            setErrors((prev) => ({ ...prev, [name]: null }));
        }
    };

    const handleSelectChange = (selectedOption, { name }) => {
        setClientData({ ...clientData, [name]: selectedOption ? selectedOption.value : "" });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const requiredFields = ["nombre_cliente", "correo_cliente", "telefono_cliente", "empresa_cliente", "tipo_cliente", "credito_cliente", "Monto_credito", "hijos", "puesto"];
        const newErrors = {};

        // Validación de campos obligatorios
        requiredFields.forEach((field) => {
            if (!clientData[field]) {
                newErrors[field] = "Este campo es obligatorio";
            }
        });

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        // Confirmación con SweetAlert
        Swal.fire({
            title: "¿Estás seguro?",
            text: "¿Deseas crear el cliente con la información proporcionada?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, crear",
            cancelButtonText: "Cancelar",
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then(async (result) => {
            if (result.isConfirmed) {
                // Mostrar preloader
                Swal.fire({
                    title: "Creando cliente",
                    text: "Por favor espere...",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

                await dispatch(crearCliente(clientData));

                // Mensaje de éxito y cierre del modal
                Swal.fire({
                    icon: "success",
                    title: "Cliente creado",
                    text: "El cliente ha sido creado exitosamente.",
                    confirmButtonText: "Aceptar",
                }).then(() => {
                    onClose(); // Cerrar el modal

                    const path = location.pathname.split("/");
                   if (path[1] === "evento" && path[2] === "crear") {
                       // No hacer nada (opcionalmente puedes añadir un comentario explicativo aquí)
                   } else if (path[1] === "cotizaciones" && path[2] === "crear") {
                       functions();
                   } else {
                       window.location.reload();
                   }
                });
            }
        });
    };

    useEffect(() => {
        const fetchEmpresa = async () => {
            const response = await dispatch(obtenerListaEmpresas());
            setEmpresas(response || []);
        };
        fetchEmpresa();
    }, [dispatch]);

    const empresaOptions = Empresas.map((empresa) => ({
        value: empresa.id_empresa,
        label: empresa.nombre_empresa,
    }));

    return (
        <Modal
            open={Boolean(open)}
            onClose={onClose}
            className="modal fade show"
            aria-labelledby="exampleModalLongTitle"
            style={{ display: "block", zIndex: 1050 }} // Ajuste del z-index
            aria-modal="true"
            role="dialog"
        >
            <div className="modal-dialog" role="document" style={{ maxWidth: "80%", margin: "1.75rem auto" }}>
                <div className="modal-content">
                    <div className="modal-body">
                        <p className="mb-0" style={{ fontSize: window.innerWidth < 600 ? "16px" : "28px" }}>
                            Crear nuevo cliente
                        </p>
                       
                            <div className="row">
                                <div className="col-sm-6">
                                    <label>Nombre cliente:</label>
                                    <input type="text" name="nombre_cliente" value={clientData.nombre_cliente} onChange={handleInputChange} className={`form-control mb-2 ${errors.nombre_cliente ? "is-invalid" : ""}`} />
                                    {errors.nombre_cliente && <div className="invalid-feedback">{errors.nombre_cliente}</div>}
                                </div>

                                <div className="col-sm-6">
                                    <label>Correo Cliente:</label>
                                    <input type="email" name="correo_cliente" value={clientData.correo_cliente} onChange={handleInputChange} className={`form-control mb-2 ${errors.correo_cliente ? "is-invalid" : ""}`} />
                                    {errors.correo_cliente && <div className="invalid-feedback">{errors.correo_cliente}</div>}
                                </div>

                                <div className="col-sm-6">
                                    <label>Número de Teléfono:</label>
                                    <input type="text" name="telefono_cliente" value={clientData.telefono_cliente} onChange={handleInputChange} className={`form-control mb-2 ${errors.telefono_cliente ? "is-invalid" : ""}`} />
                                    {errors.telefono_cliente && <div className="invalid-feedback">{errors.telefono_cliente}</div>}
                                </div>

                                <div className="col-sm-6">
                                    <label>Empresa Cliente:</label>
                                    <Select name="empresa_cliente" value={empresaOptions.find((option) => option.value === clientData.empresa_cliente)} onChange={handleSelectChange} options={empresaOptions} className={`mb-2 ${errors.empresa_cliente ? "is-invalid" : ""}`} placeholder="Seleccione Empresa" />
                                    {errors.empresa_cliente && <div className="invalid-feedback">{errors.empresa_cliente}</div>}
                                </div>

                                <div className="col-sm-6">
                                    <label>Tipo Cliente:</label>
                                    <Select name="tipo_cliente" value={tipoClienteOptions.find((option) => option.value === clientData.tipo_cliente)} onChange={handleSelectChange} options={tipoClienteOptions} className={`mb-2 ${errors.tipo_cliente ? "is-invalid" : ""}`} placeholder="Seleccione Tipo de Cliente" />
                                    {errors.tipo_cliente && <div className="invalid-feedback">{errors.tipo_cliente}</div>}
                                </div>

                                <div className="col-sm-6">
                                    <label>Crédito Cliente:</label>
                                    <Select name="credito_cliente" value={creditoOptions.find((option) => option.value === clientData.credito_cliente)} onChange={handleSelectChange} options={creditoOptions} className={`mb-2 ${errors.credito_cliente ? "is-invalid" : ""}`} placeholder="Seleccione Crédito" />
                                    {errors.credito_cliente && <div className="invalid-feedback">{errors.credito_cliente}</div>}
                                </div>

                                <div className="col-sm-6">
                                    <label>Monto Crédito:</label>
                                    <input type="number" name="Monto_credito" value={clientData.Monto_credito} onChange={handleInputChange} className={`form-control mb-2 ${errors.Monto_credito ? "is-invalid" : ""}`} />
                                    {errors.Monto_credito && <div className="invalid-feedback">{errors.Monto_credito}</div>}
                                </div>

                                <div className="col-sm-6">
                                    <label>Cumpleaños:</label>
                                    <input type="date" name="cumpleanos" value={clientData.cumpleanos} onChange={handleInputChange} className={`form-control mb-2 ${errors.cumpleanos ? "is-invalid" : ""}`} />
                                    {errors.cumpleanos && <div className="invalid-feedback">{errors.cumpleanos}</div>}
                                </div>

                                <div className="col-sm-6">
                                    <label>Hijos:</label>
                                    <input type="number" name="hijos" value={clientData.hijos} onChange={handleInputChange} className={`form-control mb-2 ${errors.hijos ? "is-invalid" : ""}`} />
                                    {errors.hijos && <div className="invalid-feedback">{errors.hijos}</div>}
                                </div>

                                <div className="col-sm-6">
                                    <label>Puesto:</label>
                                    <input type="text" name="puesto" value={clientData.puesto} onChange={handleInputChange} className={`form-control mb-2 ${errors.puesto ? "is-invalid" : ""}`} />
                                    {errors.puesto && <div className="invalid-feedback">{errors.puesto}</div>}
                                </div>

                                <div className="col-sm-6">
                                    <label>Notas Importantes:</label>
                                    <textarea name="notasImportantes" value={clientData.notasImportantes} onChange={handleInputChange} className={`form-control mb-2 ${errors.notasImportantes ? "is-invalid" : ""}`}></textarea>
                                    {/* {errors.notasImportantes && <div className="invalid-feedback">{errors.notasImportantes}</div>} */}
                                </div>
                            </div>

                            <button type="buttom" className="btn btn-primary" onClick={handleSubmit}>
                                Guardar nuevo cliente
                            </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
